module.exports = __webpack_public_path__ + "img/basket.4ff19567.svg";